// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../index.css";
// import { Button } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import Commonheader from "../CommonUtils/Commonheader";
// import { IoDocumentText } from "react-icons/io5";

// function Footer() {
//     return (
//         <div className="footer-brand-logo">
//             <p>Design and Developed by</p>
//             <img
//                 src="../images/apcfss-logo-white.svg"
//                 className="img-fluid"
//                 alt="apcfss-logo-white"
//             />
//         </div>
//     );
// }

// // ── Collapsible Parent Section ─────────────────────────────────────────────────
// const getIcon = (iconName) => {
//     if (!iconName) return null;
//     const name = iconName.trim();
//     return FiIcons[name] || HiIcons[name] || FaIcons[name] || IoIcons[name] || null;
// };

// function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen }) {

//     const [open, setOpen] = useState(false);

//     const hasActiveChild = kids.some((k) => k.service_name === activeMenu);

//     useEffect(() => {
//         if (hasActiveChild) {
//             setOpen(true);   // open only when child is active
//         }
//     }, [hasActiveChild]);

//     const ParentIcon = getIcon(parent.icon) || IoDocumentText;

//     return (
//         <li className="parent-menu">

//             <div
//                 className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
//                 role="button"
//                 tabIndex={0}
//                 onClick={() => setOpen(!open)}
//                 onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                         e.preventDefault();
//                         setOpen(!open);
//                     }
//                 }}
//             >
//                 <div className="parent-icon">
//                     {sidebarOpen && (
//                         <>
//                             <ParentIcon size={16} className="me-2" />
//                             <span>{parent.display_name}</span>
//                         </>
//                     )}
//                 </div>

//                 {!sidebarOpen && (
//                     <span title={parent.display_name}>
//                         <ParentIcon size={16} />
//                     </span>
//                 )}

//                 {sidebarOpen && (
//                     <span className="parent-arrow">{open ? "▾" : "▸"}</span>
//                 )}
//             </div>

//             {open && (
//                 <div className="children-wrapper">
//                     {kids.map((child) => {

//                         const ChildIcon = getIcon(child.icon) || FaDatabase;

//                         return (
//                             <div
//                                 key={child.service_id}
//                                 className={`child-item ${activeMenu === child.service_name ? "active" : ""}`}
//                                 role="button"
//                                 tabIndex={0}
//                                 onClick={() => onSelect(child.service_name)}
//                                 onKeyDown={(e) => {
//                                     if (e.key === "Enter" || e.key === " ") {
//                                         e.preventDefault();
//                                         onSelect(child.service_name);
//                                     }
//                                 }}
//                             >
//                                 <ChildIcon size={16} className="me-2" />
//                                 <span className="child-itemnew">{child.display_name}</span>
//                             </div>
//                         );
//                     })}
//                 </div>
//             )}

//         </li>
//     );
// }


// // ── Main Dashboard ─────────────────────────────────────────────────────────────
// export default function RusaDashboard() {
//     const navigate = useNavigate();

//     const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 576);
//     const [activeMenu, setActiveMenu] = useState(null);
//     const [accessibleMenu, setAccessibleMenu] = useState(false);

//     // ── Read from sessionStorage (set at login) ────────────────────────────────
//     const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];

//     // ── Filter + Sort ──────────────────────────────────────────────────────────
//     const allowedRoles = [1, 2, 3, 4, 5];

//     const filteredMenu = menuData
//         .filter((item) => allowedRoles.includes(item?.role_id))
//         .sort((a, b) => a.order_by - b.order_by);

//     // ── Split Parents & Children ───────────────────────────────────────────────
//     const parents = filteredMenu.filter((item) => item.parent_id === null);
//     const childrenList = filteredMenu.filter((item) => item.parent_id !== null);

//     // ── Hierarchy only when BOTH parents AND children exist ────────────────────
//     const hasHierarchy = parents.length > 0 && childrenList.length > 0;

//     // ── Accessible check ───────────────────────────────────────────────────────
//     useEffect(() => {
//         setAccessibleMenu(filteredMenu.length > 0);
//     }, []);



//     useEffect(() => {
//         setActiveMenu("home");
//         navigate("/home", { replace: true });
//     }, []);

//     // ── Responsive sidebar ─────────────────────────────────────────────────────
//     useEffect(() => {
//         const onResize = () => setSidebarOpen(window.innerWidth > 576);
//         window.addEventListener("resize", onResize);
//         return () => window.removeEventListener("resize", onResize);
//     }, []);

//     const handleSelect = (serviceName) => {
//         setActiveMenu(serviceName);
//         navigate(`/${serviceName}`);
//     };

//     return (
//         <>
//             <Commonheader />

//             {accessibleMenu && (
//                 <div className="dashboard-container second-dash">
//                     <div className="main-area1">
//                         <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

//                             <Button
//                                 className="toggle-btn"
//                                 onClick={() => setSidebarOpen(!sidebarOpen)}
//                             >

//                             </Button>

//                             <ul className={`sidebar-menu ${sidebarOpen ? "open" : "closed"}`}>
//                                 {hasHierarchy
//                                     ? // ── Parent → Child ──────────────────────────────────────
//                                     // parents.map((parent) => {
//                                     //     const childItems = childrenList
//                                     //         .filter((child) => child.parent_id === parent.service_id)
//                                     //         .sort((a, b) => a.order_by - b.order_by);

//                                     //     return (

//                                     //         <ParentSection
//                                     //             key={parent.service_id}
//                                     //             parent={parent}
//                                     //             kids={childItems}
//                                     //             activeMenu={activeMenu}
//                                     //             onSelect={handleSelect}
//                                     //             sidebarOpen={sidebarOpen}
//                                     //         />
//                                     //     );
//                                     // })



//                                     parents.map((parent) => {

//                                         const parentKids = kids
//                                             .filter((c) => c.parent_id === parent.service_id)
//                                             .sort((a, b) => a.order_by - b.order_by);

//                                         const ParentIcon = getIcon(parent.icon) || FaDatabase;

//                                         // 🔹 Parent WITH children → dropdown
//                                         if (parentKids.length > 0) {
//                                             return (
//                                                 <ParentSection
//                                                     key={parent.service_id}
//                                                     parent={parent}
//                                                     kids={parentKids}
//                                                     activeMenu={activeMenu}
//                                                     onSelect={handleSelect}
//                                                     sidebarOpen={sidebarOpen}
//                                                 />
//                                             );
//                                         }

//                                         // 🔹 Parent WITHOUT children → direct route
//                                         return (
//                                             <li
//                                                 key={parent.service_id}
//                                                 className={`single-menu ${activeMenu === parent.service_name ? "active" : ""}`}
//                                                 role="button"
//                                                 tabIndex={0}
//                                                 onClick={() => handleSelect(parent.service_name)}
//                                                 onKeyDown={(e) => {
//                                                     if (e.key === "Enter" || e.key === " ") {
//                                                         e.preventDefault();
//                                                         handleSelect(parent.service_name);
//                                                     }
//                                                 }}
//                                             >
//                                                 <ParentIcon size={16} className="me-2" />
//                                                 {sidebarOpen && <span>{parent.display_name}</span>}
//                                             </li>
//                                         );
//                                     })
//                                     : // ── Flat List ────────────────────────────────────────────
//                                     filteredMenu.map((item) => (

//                                         <li
//                                             key={item.service_id}
//                                             className={`single-menu ${activeMenu === item.service_name ? "active" : ""}`}
//                                             onClick={() => handleSelect(item.service_name)}
//                                             tabIndex={0}         // makes li focusable
//                                             role="button"        // tells screen readers this acts like a button
//                                             onKeyDown={(e) => {
//                                                 if (e.key === "Enter" || e.key === " ") {
//                                                     e.preventDefault();
//                                                     handleSelect(item.service_name);
//                                                 }
//                                             }}
//                                         >
//                                             {item.display_name}
//                                             {console.log("dd", item.display_name)}
//                                         </li>
//                                     ))}
//                             </ul>

//                         </aside>
//                     </div>
//                 </div>
//             )}

//             <Footer />
//         </>
//     );
// }



import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Commonheader from "../CommonUtils/Commonheader";
import { FaDatabase } from "react-icons/fa";
import { getIcon, ParentSection, MenuItem } from "./ParentSection";

function Footer() {
    return (
        <div className="footer-brand-logo">
            <p>Design and Developed by</p>
            <img
                src="../images/apcfss-logo-white.svg"
                className="img-fluid"
                alt="apcfss-logo-white"
            />
        </div>
    );
}

export default function RusaDashboard() {
    const navigate = useNavigate();

    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 576);
    const [activeMenu, setActiveMenu] = useState(null);
    const [accessibleMenu, setAccessibleMenu] = useState(false);

    const menuData = JSON.parse(sessionStorage.getItem("menuData")) || [];

    const allowedRoles = [1, 2, 3, 4, 5];

    const filteredMenu = menuData
        .filter((item) => allowedRoles.includes(item?.role_id))
        .sort((a, b) => a.order_by - b.order_by);

    const parents = filteredMenu.filter((item) => item.parent_id === null);
    const childrenList = filteredMenu.filter((item) => item.parent_id !== null);
    const hasHierarchy = parents.length > 0 && childrenList.length > 0;

    useEffect(() => {
        setAccessibleMenu(filteredMenu.length > 0);
    }, []);

    useEffect(() => {
        setActiveMenu("home");
        navigate("/home", { replace: true });
    }, []);

    useEffect(() => {
        const onResize = () => setSidebarOpen(window.innerWidth > 576);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const handleSelect = (serviceName) => {
        setActiveMenu(serviceName);
        navigate(`/${serviceName}`);
    };

    // ── Build menu items ────────────────────────────────────────────────────────
    const menuItems = hasHierarchy
        ? parents.map((parent) => ({
            item: parent,
            kids: childrenList
                .filter((c) => c.parent_id === parent.service_id)
                .sort((a, b) => a.order_by - b.order_by),
        }))
        : filteredMenu.map((item) => ({ item, kids: [] }));

    return (
        <>
            <Commonheader />

            {accessibleMenu && (
                <div className="dashboard-container second-dash">
                    <div className="main-area1">
                        <aside className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>

                            <Button
                                className="toggle-btn"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            />

                            <ul className={`sidebar-menu ${sidebarOpen ? "open" : "closed"}`}>
                                {menuItems.map(({ item, kids }) => (
                                    <MenuItem
                                        key={item.service_id}
                                        item={item}
                                        kids={kids}
                                        activeMenu={activeMenu}
                                        onSelect={handleSelect}
                                        sidebarOpen={sidebarOpen}
                                        defaultIcon={FaDatabase}
                                    />
                                ))}
                            </ul>

                        </aside>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
}